// Horizontal step indicator for multi-step flows (Provisioning wizard).
// Stateless and content-free: the caller owns `current` (0-based) and renders
// the step body itself. Completed steps show a check, the active step is filled
// with the brand gradient, upcoming steps stay muted.
export function Stepper({ steps = [], current = 0, className = '' }) {
  return (
    <ol className={`flex items-center gap-2 ${className}`} aria-label="Progress">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={label} className="flex flex-1 items-center gap-2 last:flex-none">
            <span
              aria-current={active ? 'step' : undefined}
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold ring-1 ring-inset transition-colors ${
                active
                  ? 'bg-brand-gradient text-white ring-transparent shadow-brand'
                  : done
                    ? 'bg-brand/15 text-brand-dark ring-brand/25 dark:bg-brand/25 dark:text-brand-light dark:ring-brand/30'
                    : 'bg-slate-100 text-slate-400 ring-slate-300/60 dark:bg-white/10 dark:text-slate-500 dark:ring-white/15'
              }`}
            >
              {done ? (
                <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
                  <path d="M5 10.5l3.5 3.5L15 6.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              ) : (
                i + 1
              )}
            </span>
            <span
              className={`whitespace-nowrap text-xs font-medium ${
                active
                  ? 'text-navy-800 dark:text-slate-100'
                  : 'text-slate-400 dark:text-slate-500'
              }`}
            >
              {label}
            </span>
            {i < steps.length - 1 && (
              <span
                aria-hidden="true"
                className={`h-px flex-1 ${done ? 'bg-brand/40' : 'bg-slate-200 dark:bg-white/10'}`}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
